import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilesPanelComponent } from './profiles-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ProfilesPanelComponent],
  exports: [
    ProfilesPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class ProfilesPanelModule { }
